import { render, staticRenderFns } from "./DeviceManager.vue?vue&type=template&id=2c5460e8&scoped=true"
import script from "./DeviceManager.vue?vue&type=script&lang=js"
export * from "./DeviceManager.vue?vue&type=script&lang=js"
import style0 from "./DeviceManager.vue?vue&type=style&index=0&id=2c5460e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5460e8",
  null
  
)

export default component.exports